import React from 'react';
import { Card, CardTitle, CardContent, Typography, Button, CardActions, } from '@one-thd/sui-atomic-components';
import { stashLinkEvent } from '../../utils/analytics';
export var SecuritySignInCard = function () {
    var cardTitleHeader = (React.createElement(Typography, { height: "tight", variant: "h3", weight: "bold" }, "Security & Sign-In"));
    var onClickLink = function () {
        stashLinkEvent('account dashboard: security and sign in: manage sign in');
    };
    return (React.createElement(Card, { grow: true, PaperProps: { className: 'sui-flex sui-h-full' } },
        React.createElement(CardTitle, { header: cardTitleHeader, disableActionSpacing: true }),
        React.createElement(CardContent, { className: "sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full" },
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, null, "View and edit your account email, password, contact phone and signed-in devices."))),
        React.createElement(CardActions, null,
            React.createElement("a", { href: "/myaccount/security", className: "sui-w-full", onClick: onClickLink },
                React.createElement(Button, { fullWidth: true, variant: "secondary" }, "Manage Sign-In")))));
};
